import axios from "axios";
import { getUrlApi } from "../utils/util";

class plataformService {
    async getBanners() {
        var url = `${await getUrlApi()}/public/banners`;
        return axios.get(`${url}`);
    }
}

export default new plataformService();